import * as React from 'react';
import { useCommon } from 'src/domains/common/Common';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';
import { EventMarkets } from 'src/domains/sportsbook/webview/components/eventMarkets/EventMarkets';
import { EventRowWrapper } from 'src/domains/sportsbook/webview/components/eventRow/EventRow.style';
import { EventRowMarkets } from 'src/domains/sportsbook/webview/components/sportEventsListNew/EventRowMobx.style';
import { ChevronWrapper } from 'src/ui/components/collapse/sports/05/Collapse.style';
import {
    RowLinkDetails,
    RowLinkLabel,
    RowLinkLabelWrapper,
    TableSportsRowLinkWrapper,
} from 'src/ui/components/table/sports/row/link/TableSportsRowLink.style';
import { getSimpleDate } from 'src/utils/date';
import { observer } from 'src/utils/mobx-react';
import { EventListGroupEventItemType } from 'src_common/common/websocket2/modelsApi/EventsCollectionQuery';

interface EventRowNameLinkPropsType {
    className?: string;
    dataTest?: string;
    flagCode?: string;
    formattedDate: string;
    handleClick: () => void;
    label: string;
}

export const EventRowNameLink = observer(
    'EventRowNameLink',
    ({ className, dataTest, formattedDate, handleClick, label }: EventRowNameLinkPropsType): JSX.Element => {
        const sportsbookVariant = DefaultComponentVariantType.TERTIARY;
        return (
            <TableSportsRowLinkWrapper
                className={className}
                onClick={handleClick}
                data-test={dataTest ?? 'outrights-row-link-wrapper'}
                variant={sportsbookVariant}
            >
                <RowLinkLabelWrapper>
                    <RowLinkLabel data-test='outrights-row-link-label'>{label}</RowLinkLabel>
                    {formattedDate !== '' && (
                        <RowLinkDetails variant={sportsbookVariant}>{formattedDate}</RowLinkDetails>
                    )}
                </RowLinkLabelWrapper>
                <ChevronWrapper
                    size={20}
                    position={'right'}
                />
            </TableSportsRowLinkWrapper>
        );
    }
);

interface EventRowUnifiedPropsType {
    smallEvent: EventListGroupEventItemType;
}

export const EventRowOutrightsUnified = observer('EventRowOutrightsUnified', (props: EventRowUnifiedPropsType) => {
    const {
        smallEvent: { id, name, startTime, id2: eventId },
    } = props;
    const common = useCommon();
    const starRouter = StarRouter.get(common);

    const formattedDate = startTime ? getSimpleDate(new Date(startTime).toISOString(), LanguagesState.get(common)) : '';

    const handleClick = (): void => {
        starRouter.redirectToEvent(eventId);
    };

    const actualEvent = eventId.getEventModel();

    if (actualEvent === null) {
        return null;
    }

    const markets = (actualEvent.eventMarkets ?? []).slice(0, 3);

    return (
        <EventRowWrapper
            variant={DefaultComponentVariantType.TERTIARY}
            isOutrights
            data-testid='event-row-outrights-unified'
        >
            <EventRowNameLink
                key={id}
                label={name}
                formattedDate={formattedDate}
                handleClick={handleClick}
            />
            <EventRowMarkets>
                <EventMarkets
                    markets={markets}
                    eventId={eventId}
                />
            </EventRowMarkets>
        </EventRowWrapper>
    );
});
